// extracted by mini-css-extract-plugin
export default {"settingsContainer":"mpwdLrFUMeDZD78cOEQU__settingsContainer___","content":"fIpU8Y2QXAsqxkV0SDJc__content___"};